import React from 'react'
import styled from 'styled-components'
import { LabelStyle, SmallStyle } from 'components/styled/typography/styles'
import { Box } from 'components/styled/containers/box'
import {
  StyledTextArea,
  StyledTextAreaProps,
} from 'components/form-components/styled-text-area'
import FormErrors from 'components/form-components/form-errors'

export interface FieldProps extends StyledTextAreaProps {
  title: string
  subtitle?: string
  isRequired?: boolean
}

const StyledField = styled.div`
  margin-bottom: ${({ theme }) => theme.space.s20};
`

const FieldLabel = styled.span`
  ${LabelStyle};
  margin-bottom: ${({ theme }) => theme.space.s20};
  color: ${({ theme }) => theme.color.grey90};
`

const FieldSubLabel = styled.span`
  ${SmallStyle};
  font-style: italic;
  margin-left: ${({ theme }) => theme.space.s4};
  margin-bottom: ${({ theme }) => theme.space.s8};
`

export const LabelledTextArea: React.FC<FieldProps> = ({
  title,
  subtitle,
  isRequired = false,
  model,
  ...props
}) => {
  return (
    <StyledField>
      <Box mb="s8">
        <FieldLabel>{`${title} ${isRequired ? '*' : ''}`}</FieldLabel>
        {subtitle && <FieldSubLabel>{subtitle}</FieldSubLabel>}
      </Box>
      <StyledTextArea {...props} model={model} />
      <FormErrors model={model} />
    </StyledField>
  )
}
